// Résolution des sons de l'application : personnalisés en admin (Réglages) ou par défaut.
// Lecture FRAÎCHE à chaque ouverture — un réglage changé dans l'admin (puissance
// de la vague ou bruitage personnalisé) s'entend dès la page suivante.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
    opening: "/audio/ouverture.wav",
    ambiance: "/audio/vagues.wav",
    waveVolume: 0.05,
};

export async function getAppSounds() {
    try {
        const r = await fetch(`${API}/settings/public`);
        const s = (await r.json()).settings || {};
        return {
            opening: s.sound_opening ? `${API}/media/${s.sound_opening}` : DEFAULTS.opening,
            ambiance: s.sound_ambiance ? `${API}/media/${s.sound_ambiance}` : DEFAULTS.ambiance,
            // Puissance de la vague (0-100 % réels), réglée par Julie dans Admin → Réglages.
            // 0 = silence total, 100 = volume intégral du bruitage. Aucun plafond caché.
            waveVolume: Math.min(100, Math.max(0, Number(s.wave_volume ?? 5))) / 100,
        };
    } catch {
        return { ...DEFAULTS };
    }
}
